import * as yup from "yup";

// const passwordRegExp = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/;

const LoginVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is Required")
    .email("Invalid Email")
    .label("email"),
  password: yup.string().required("Password is Required").label("password"),
});

const ForgotPasswordVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is Required")
    .email("Invalid Email")
    .label("email"),
});

const ResetPasswordVS = yup.object().shape({
  password: yup.string().required("Password is required"),
  confirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

export const builderAccountValidation = yup.object().shape({
  displayName: yup.string().trim().required("Display name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  companyName: yup.string().trim().required("Company Name is required"),
  companyAddress: yup.string().trim().required("Company Address is required"),
  companyWebsite: yup
    .string()
    .trim()
    .matches(
      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i,
      "Enter a valid website (e.g., example.com)"
    )
    .required("Company Website is required"),
  businessCellNumber: yup
    .string()
    .matches(/^[+]?[\d\s()-]{7,20}$/, "Enter a valid phone number")
    .required("Phone number is required"),
});

export const clientAccountValidation = yup.object().shape({
  displayName: yup.string().trim().required("Display name is required"),
  currentAddress: yup.string().trim().optional(),
  billingAddress: yup.string().trim().optional(),
});

export const designerAccountValidation = yup.object().shape({
  displayName: yup.string().trim().required("Display name is required"),
});

export const collaboratorAccountValidation = yup.object().shape({
  displayName: yup.string().trim().required("Display name is required"),
  email: yup
    .string()
    .trim()
    .email("Invalid email")
    .required("Email is required"),
  phoneNumber: yup
    .string()
    .matches(/^[+]?[\d\s()-]{7,20}$/, "Enter a valid phone number")
    .required("Phone number is required"),
});

export const collaboratorValidation = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  role: yup
    .string()
    .oneOf(["collaborator", "builder"], "Please select a role")
    .required("Role is required"),
});

export const passwordChangeValidation = yup.object({
  currentPassword: yup.string().required("Current password is required"),

  newPassword: yup
    .string()
    .min(8, "New password must be at least 8 characters")
    .required("New password is required"),

  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Passwords must match")
    .required("Please confirm your new password"),
});

export const contactFormValidation = (maxWords: number = 3000) =>
  yup.object({
    fullName: yup
      .string()
      .trim()
      .min(3, "Full name must be at least 3 characters")
      .required("Full name is required"),

    phone: yup
      .string()
      .matches(/^[+]?[\d\s()-]{7,20}$/, "Enter a valid phone number")
      .required("Phone number is required"),

    email: yup
      .string()
      .email("Enter a valid email")
      .required("Email is required"),

    message: yup
      .string()
      .required("Message is required")
      .max(maxWords, `Message cannot exceed ${maxWords} characters`),
  });

export const StepOneVS = yup.object().shape({
  projectName: yup.string().trim().required("Project name is required"),
  currentAddress: yup.string().trim().required("Current address is required"),
  billingAddress: yup.string().trim().required("Billing address is required"),
});

export const StepTwoVS = yup.object().shape({
  imageItems: yup.array().of(
    yup.object().shape({
      imageLabel: yup.string().trim().required("File label is required"),
      notes: yup.string().trim().optional(),
      file: yup.mixed().nullable(),
      hasImage: yup.boolean(),
      imageUrl: yup.string().optional(),
    }).test(
      "image-required",
      "Image is required",
      function (item: any) {
        return !!(item?.hasImage || item?.file || item?.imageUrl);
      },
    ),
  ),
});

export const changeRequestValidation = yup.object().shape({
  clientComment: yup
    .string()
    .required("Please describe what you'd like to change")
    .min(10, "Description must be at least 10 characters"),
  imageItems: yup
    .array()
    .of(
      yup.object().shape({
        imageLabel: yup.string().when("hasImage", {
          is: true,
          then: (schema) => schema.required("File label is required"),
          otherwise: (schema) => schema,
        }),
        notes: yup.string().when("hasImage", {
          is: true,
          then: (schema) => schema.required("Additional notes are required"),
          otherwise: (schema) => schema,
        }),
        hasImage: yup.boolean(),
        file: yup.mixed().nullable(),
      }),
    ),
});

export { LoginVS, ForgotPasswordVS, ResetPasswordVS };
